import { makeStyles } from "@material-ui/core/styles";

const addShotToSequencerTimelineModalStyles = makeStyles((theme) => ({
  modalRoot: {
    height: "800px",
    width: "80vw",
    backgroundColor: "#1B1D28",
    padding: "18px",
    borderRadius: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    position: "relative",
  },
  breadCrumb: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  searchAndSortOptions: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  multiSelectButton: {
    backgroundColor: "#2D2F3A",
    padding: "8px 16px",
    borderRadius: "5px",
  },
  popoverCard: {
    backgroundColor: "#252A38",
    border: "1px solid #606479",
    borderRadius: "5px",
    width: "250px",
    marginTop: "10px",
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  singlePopoverItem: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    cursor: "pointer",
    padding: "10px",
    "&:hover": {
      backgroundColor: "#353A47",
    },
  },
  popoverItemTitle: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  popoverItemTitleText: {
    fontSize: "14px !important",
  },
  popoverItemHelperText: {
    fontSize: "12px !important",
    color: "#B1B5C9",
  },
  singleSequenceCard: {
    padding: "10px",
    backgroundColor: "#252A38",
    borderRadius: "5px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    cursor: "pointer",
  },
  selectStatusDropdownContainer: {
    backgroundColor: theme.palette.secondary.light,
    padding: "4px",
    borderRadius: "10px",
    width: "100%",
    marginTop: "5px",
    width: "100%",
  },
  dropdownSelect: {
    padding: "0.2px 6px",
  },
  // select status/task design
  backButton: {
    width: "100%",
    textAlign: "left !important",
    display: "flex",
    justifyContent: "flex-start",
    padding: "8px 16px",
    fontSize: "14px",
  },
  choosePart: {
    backgroundColor: "#1B1D28",
    padding: "8px 16px",
  },
  chooseLabel: {
    color: "#606479",
    fontSize: "12px !important",
  },
  applyChangesButton: {
    width: "100%",
    backgroundColor: "#6C65D9",
    fontSize: "14px",
    "&:disabled": {
      backgroundColor: "#353B47",
      color: "gray",
    },
  },
  selectionContainer: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  shotName: {
    color: "#B1B5C9",
    fontSize: "14px !important",
  },
  inTimelineIndicator: {
    color: "#6C65D9",
    fontSize: "14px !important",
  },
  datePickerComponent: {
    // marginLeft: "4px",
    // marginBottom: "2.2px",
    padding: "9px",
    borderRadius: "5px",
    backgroundColor: theme.palette.secondary.light,
    width: "100%",
    minHeight: "28px",
  },
  shotsContainer: {
    overflowY: "auto",
    marginBottom: "55px",
  },
}));

export default addShotToSequencerTimelineModalStyles;
